import { useMemo } from 'react';

const getSupport = () => {
  const el = document.createElement('input');
  return el.capture != undefined;
};
const useCaptureSupported = () => useMemo(getSupport, []);

export default useCaptureSupported;
